export const translations = {
  en: {
    appName: 'MyTownly',
    tagline: 'Grocery delivery in Piler',
    town: 'Piler, Andhra Pradesh',
    langToggle: 'తెలుగు',
    langName: 'English',
    blocked: {
      title: 'Account suspended',
      message: 'Your account has been blocked. You cannot place orders. Contact support if you think this is a mistake.',
      contact: 'Contact support on WhatsApp',
      logout: 'Log out',
    },
    location: {
      title: 'Enable delivery location',
      message: 'We use your GPS once to save your address and help riders find you faster at checkout.',
      enable: 'Enable location',
      skip: 'Not now',
      detecting: 'Detecting your location…',
      confirmTitle: 'Confirm your address',
      save: 'Save as default address',
      saved: 'Delivery location saved!',
      denied: 'Location permission denied. You can add your address manually.',
      failed: 'Could not detect location. Try again or add address manually.',
      saveFailed: 'Could not save address. Try again.',
    },
    delivery: {
      deliverTo: 'Deliver to',
      currentLocation: 'Current location',
      pinnedLocation: 'Pinned location',
      useCurrentLocation: 'Use my current location',
      refreshLocation: 'Refresh location',
      detecting: 'Detecting your location…',
      gpsFailed: 'Could not detect location. Pick a saved address or set on map.',
      changeLocation: 'Change',
      savedAddresses: 'Saved addresses',
      manageAddresses: 'Manage addresses',
      setOnMap: 'Set on map',
      adjustOnMap: 'Adjust pin on map',
      pinTitle: 'Confirm delivery location',
      pinHint: 'Drag the pin to your exact delivery spot. We will fill the address automatically.',
      confirmPin: 'Confirm location',
      pinConfirmed: 'Delivery location confirmed',
      updatingAddress: 'Updating address…',
      whereInPiler: 'Where in Piler?',
      whereInPilerSub: 'Local shops deliver in ~30 min. Set your spot so riders find you easily.',
      searchPlaceholder: 'Search area, street, or landmark',
      searchFailed: 'Could not find that place. Try map pin instead.',
      gpsHint: 'Helps riders reach your door faster',
      enable: 'Enable',
      permissionOff: 'Location permission is off',
      permissionOffSub: 'Tap Enable to allow GPS, or pin your spot on the map below.',
      browseWithoutLocation: 'Browse without setting location',
      setLocationBanner: 'Set your delivery location for faster checkout',
      outOfAreaTitle: 'We deliver within 3 km of Piler',
      outOfAreaMessage: 'This pin is outside our 3 km delivery zone around Piler. Move the pin closer to town.',
      outOfAreaShort: 'Outside our 3 km Piler delivery zone.',
      notifyExpansion: 'Notify me when we expand',
    },
    nav: { home: 'Home', grocery: 'Grocery', orders: 'Orders', profile: 'Profile' },
    common: {
      back: 'Back', save: 'Save', cancel: 'Cancel', confirm: 'Confirm', loading: 'Loading...',
      soon: 'SOON', free: 'FREE', total: 'Total', search: 'Search',
      orderNow: 'Order now →', browseGrocery: 'Browse Grocery', tryAgain: 'Try again',
    },
    legal: {
      section: 'Legal',
      termsPrefix: 'By continuing you agree to our',
      terms: 'Terms of Service',
      termsAnd: ' & ',
      privacy: 'Privacy Policy',
    },
    greeting: { morning: 'Good morning', afternoon: 'Good afternoon', evening: 'Good evening' },
    home: {
      searchPlaceholder: 'Search groceries, shops...',
      quickShop: 'Shop', quickOrders: 'Orders', quickAddresses: 'Addresses', quickHelp: 'Help',
      orderGroceries: 'Order groceries', orderSub: 'Fresh from local shops in Piler',
      shopTitle: 'Shop Groceries', shopDesc: 'Delivered to your door in 30 min',
      offers: 'Offers for you', whyUs: 'Why MyTownly?',
      fastDelivery: 'Fast delivery', fastSub: '30 min avg',
      cashUpi: 'Cash & UPI', cashSub: 'Pay your way',
      madeForPiler: 'Made for Piler', madeSub: 'Local shops',
      firstOrderPromo: 'Your first order gets free delivery!',
      offer1Title: 'Free delivery on first order!', offer1Desc: 'Automatically applied at checkout',
      offer2Title: 'Free delivery above ₹{amount}', offer2Desc: 'On every grocery order in Piler',
      comingSoon: 'Coming to Piler', autoRides: 'Auto rides', autoRidesSub: 'Tap to get notified at launch',
      food: 'Food delivery', foodSub: 'Tap to get notified at launch',
    },
    tour: {
      skip: 'Skip',
      next: 'Next →',
      startShopping: 'Start shopping 🛒',
      welcomeIcon: '🏘️',
      welcomeTitle: 'Welcome to MyTownly!',
      welcomeBody: 'A quick 4-step tour will show you where everything is.',
      locationIcon: '📍',
      locationTitle: 'Your delivery spot',
      locationBody: 'Tap here first to set where groceries should be delivered.',
      shopIcon: '🛒',
      shopTitle: 'Shop groceries',
      shopBody: 'Open the shop here — browse items and tap + to add to cart.',
      checkoutIcon: '💳',
      checkoutTitle: 'Your cart & checkout',
      checkoutBody: 'Tap the cart icon when ready. Choose Cash or UPI — first order is free delivery!',
      trackIcon: '📦',
      trackTitle: 'Track orders',
      trackBody: 'All your orders live here. Tap to see status and live tracking.',
    },
    login: {
      enterPhone: 'Enter your mobile number', phoneSub: "We'll send a one-time password to verify it's you",
      sendOtp: 'Send OTP →', enterOtp: 'Enter OTP', sentTo: 'Sent to +91 {phone}', change: 'Change',
      verifyOtp: 'Verify OTP →', resend: 'Resend OTP', noOtp: "Didn't receive?",
      yourName: "What's your name?", nameSub: 'Just once — so we know what to call you 😊',
      namePlaceholder: 'Your full name', letsGo: "Let's go! 🎉",
      terms: 'By continuing you agree to our Terms & Privacy Policy',
      otpSent: 'OTP sent! Check your SMS 📱', welcome: 'Welcome to MyTownly, {name}! 🎉',
      invalidPhone: 'Enter a valid 10-digit number', invalidOtp: 'Enter complete 6-digit OTP',
      emptyName: 'Please enter your name',
      phonePlaceholder: '10-digit number',
      otpHint: 'Paste OTP from SMS or tap the code suggestion above the keyboard',
    },
    authErrors: {
      invalidPhone: 'Invalid phone number. Enter a valid 10-digit Indian mobile number.',
      tooManyRequests: 'Too many attempts. Please wait a few minutes and try again.',
      captchaFailed: 'Security check failed. Refresh the page and try again.',
      invalidOtp: 'Wrong OTP. Please check the code and try again.',
      codeExpired: 'OTP expired. Tap Resend OTP to get a new one.',
      missingOtp: 'Enter the complete 6-digit OTP.',
      quotaExceeded: 'SMS quota exceeded. Contact support or try again later.',
      appNotAuthorized: 'App not verified for OTP. In Firebase Console → Project settings → MyTownly (in.mytownly.customer) → add your debug SHA-1 fingerprint, then try again.',
      timeout: 'OTP request timed out. Check your network and try again.',
      networkFailed: 'Network error. Check your internet connection.',
      refererBlocked: 'This site is blocked by your Firebase API key. Add your domain to HTTP referrers in Google Cloud Console.',
      noOtpSession: 'No OTP session. Please request a new OTP.',
      profilePermission: 'Could not save your profile. Close the app, reopen, and try again.',
      default: 'Something went wrong. Please try again.',
    },
    notifications: {
      title: 'Order updates',
      desc: 'Get sound alerts when your order is packed or out for delivery',
      enable: 'Enable',
      enabled: 'Notifications on! You’ll hear order updates 🔔',
      blocked: 'Notifications blocked — enable in browser settings',
      failed: 'Could not enable notifications',
    },
    grocery: {
      title: 'Grocery', shopsNear: 'Shops near you', shopsSub: 'Delivering across Piler',
      searchProducts: 'Search products...', noShops: 'No shops available yet',
      noShopsSub: "We're onboarding local stores in Piler. Check back soon!",
      noProducts: 'No products found', noProductsSub: 'Try a different category or search term',
      clearSearch: 'Clear search', viewCart: 'View Cart →', items: 'item', itemsPlural: 'items',
      addedToCart: 'Added to cart',
      defaultUnit: '1 piece',
      loadError: 'Could not load',
      loadErrorShops: 'Check your connection and try again.',
      loadErrorProducts: 'Could not load products for this shop. Try again.',
      categories: { all: 'All', vegetables: 'Veggies', fruits: 'Fruits', dairy: 'Dairy', grains: 'Grains', snacks: 'Snacks', spices: 'Spices' },
    },
    cart: {
      title: 'My Cart', empty: 'Your cart is empty', emptySub: 'Add fresh groceries from local shops in Piler',
      deliveryAddress: 'Delivery Address', manage: 'Manage', differentAddress: 'Enter a different address',
      addressPlaceholder: 'House no., street, landmark in Piler...',
      priceSummary: 'Price Summary', subtotal: 'Subtotal ({count} items)', deliveryFee: 'Delivery fee',
      freeDelivery: 'FREE', firstOrderFreeNote: 'First order — free delivery applied',
      paymentMethod: 'Payment Method', cod: '💵 Cash on Delivery', codSub: 'Pay when delivered',
      online: '📱 UPI / Card', onlineSub: 'Pay now securely',
      placeOrder: 'Place Order — ₹{total}', payOrder: 'Pay ₹{total} →',
      needAddress: 'Please enter your delivery address', needPinLocation: 'Pin your location on the map (within 3 km of Piler)', emptyCart: 'Cart is empty',
      setLocationForFee: 'Set delivery pin to see fee',
      locationRequired: 'Set your delivery location on the map to continue',
      activeOrderBlock: 'You already have an active order. Wait until it is delivered or cancelled.',
      paymentPendingBlock: 'Complete or cancel your pending payment before placing a new order.',
      maxOrderExceeded: 'Order total cannot exceed ₹{max}',
      orderPlaced: 'Order placed! 🎉', orderFailed: 'Failed to place order. Try again.',
      paymentFailed: 'Payment failed: {msg}', paymentSetupFailed: 'Payment setup failed. Try cash option.',
      paymentDismissed: 'Payment cancelled.',
      paymentNotVerified: 'Payment could not be verified. Contact support if amount was deducted.',
      codFallbackTitle: 'Pay with cash instead?',
      codFallbackMessage: 'Online payment did not go through. Switch this order to Cash on Delivery — pay when your items arrive.',
      codFallbackSuccess: 'Order placed with Cash on Delivery 🎉',
      codFallbackLater: 'Not now',
      switchToCod: 'Yes — pay cash on delivery',
      codLabel: 'COD',
      mixedShops: 'Cart has items from different shops. Remove extras or clear cart.',
      shopSwitchCleared: 'Cart cleared — switched to another shop.',
      processing: 'Processing…',
    },
    orders: {
      title: 'My Orders', empty: 'No orders yet', emptySub: 'Your grocery orders from local Piler shops will show up here',
      orderGroceries: 'Order Groceries', paymentPending: 'Awaiting payment',
      completePayment: 'Complete payment',
      payNow: 'Pay now',
      pending: 'Pending', confirmed: 'Confirmed', ready: 'Ready',
      onTheWay: 'On the way', delivered: 'Delivered', cancelled: 'Cancelled', failed: 'Payment failed',
    },
    track: {
      title: 'Track Order', loading: 'Loading your order...', progress: 'Order progress',
      estimated: 'Estimated: 25–35 mins', deliveredSuccess: 'Delivered successfully!',
      orderSummary: 'Order Summary', totalPaid: 'Total', orderAgain: 'Order Again 🎉',
      copied: 'Order ID copied!',
      notFound: 'Order not found',
      notFoundSub: 'This order may have expired or you may not have access. Check My Orders.',
      loadError: 'Could not load order',
      loadErrorSub: 'Check your connection and try again.',
      cancelOrder: 'Cancel order',
      cancelConfirmTitle: 'Cancel this order?',
      cancelConfirm: 'You can only cancel before the shop accepts your order.',
      cancelling: 'Cancelling…',
      cancelled: 'Order cancelled',
      cancelFailed: 'Could not cancel — shop may have already accepted',
      needHelp: 'Need help with this order?',
      whatsappHelp: 'Chat on WhatsApp — we\'ll reply with your order details',
      payWithCod: '💵 Pay with Cash on Delivery',
      steps: {
        pending: { label: 'Order Placed', desc: 'Your order has been received' },
        payment_pending: { label: 'Awaiting payment', desc: 'Pay online, switch to cash, or cancel' },
        confirmed: { label: 'Confirmed', desc: 'Shop confirmed — rider will pick up soon' },
        ready: { label: 'Ready', desc: 'Order packed and waiting for pickup' },
        picked_up: { label: 'On the way', desc: 'Rider is heading to you' },
        delivered: { label: 'Delivered', desc: 'Enjoy your order!' },
        cancelled: { label: 'Order cancelled', desc: 'This order was cancelled' },
        failed: { label: 'Payment failed', desc: 'Retry online or pay cash on delivery' },
      },
      deliveryPartner: 'Delivery partner',
      rateRider: 'Rate your delivery',
      rateRiderSub: 'How was {name}?',
      submitRating: 'Submit rating',
      ratingThanks: 'Thanks for your feedback!',
      ratingFailed: 'Could not save rating. Try again.',
      ratedStars: 'You rated {stars} stars',
    },
    profile: {
      account: 'Account',
      completeProfile: 'Complete your profile',
      addYourName: 'Add your name for a personalised experience',
      orderCount: '{count} orders',
      deliveredCount: '{count} delivered',
      activeOrder: 'Order in progress',
      track: 'Track',
      editName: 'Edit name', nameUpdated: 'Name updated', loggedOut: 'Logged out',
      memberSince: 'Member since {date}',
      statsOrders: 'Orders', statsDelivered: 'Delivered', statsAddresses: 'Addresses',
      quickActions: 'Quick actions', shopNow: 'Shop now', viewOrders: 'View orders',
      defaultAddress: 'Default delivery address', addAddress: 'Add your address',
      noAddressSub: 'Save home or work for faster checkout',
      referTitle: 'Refer & earn ₹{amount}', referSub: 'Share your code with friends in Piler',
      copyCode: 'Copy', codeCopied: 'Copied!',
      sectionAccount: 'Account', sectionSettings: 'Settings', sectionSupport: 'Support',
      myOrders: 'My Orders', myOrdersSub: 'Track & view past orders',
      addresses: 'Saved Addresses', addressesSub: 'Home, work & more',
      payments: 'Payments', paymentsSub: 'UPI, cash on delivery',
      refer: 'Refer & Earn', referSub: 'Get ₹50 per referral',
      help: 'Help & Support', helpSub: 'WhatsApp, call & FAQ',
      logout: 'Log Out', version: 'MyTownly v{version} · Made with ❤️ in Piler, AP',
      language: 'Language', languageSub: 'English / తెలుగు',
    },
    help: {
      title: 'Help & Support',
      whatsappTitle: 'Chat on WhatsApp',
      whatsappSub: 'Fastest response · Usually within 1 hour',
      callTitle: 'Call us',
      emailTitle: 'Email support',
      faqTitle: 'Frequently asked',
      faq: {
        deliveryQ: 'How long does delivery take?',
        deliveryA: 'Most grocery orders in Piler are delivered within 30–35 minutes, depending on the shop and your location.',
        paymentQ: 'What payment methods do you accept?',
        paymentA: 'We accept Cash on Delivery (COD) and online payments via UPI, cards, and wallets through Razorpay.',
        minimumQ: 'Is there a minimum order amount?',
        minimumA: 'No minimum order. A flat delivery fee of ₹20 applies to every order.',
        trackQ: 'Can I track my order?',
        trackA: 'Yes! Go to Orders in the bottom menu and tap your order to see live status updates.',
        areaQ: 'What areas do you deliver to?',
        areaA: 'We currently deliver within {town}. We\'re expanding to nearby areas soon.',
      },
    },
    splash: { sub: 'Grocery Delivery · Piler' },
    address: {
      saveAs: 'Save as',
      types: { home: 'Home', work: 'Work', other: 'Other' },
      houseNo: 'House / Flat / Block No.',
      houseNoPlaceholder: 'e.g. 12-34, Flat 2B',
      building: 'Building / Street / Colony',
      buildingPlaceholder: 'e.g. Sri Rama Colony, Main Road',
      landmark: 'Landmark (optional)',
      landmarkPlaceholder: 'e.g. Near Hanuman Temple',
      area: 'Area / Locality',
      pincode: 'Pincode',
      cityState: 'City',
      receiverName: 'Receiver name (optional)',
      receiverNamePlaceholder: 'Who will receive the order?',
      receiverPhone: 'Receiver mobile (optional)',
      setDefault: 'Set as default delivery address',
      houseNoRequired: 'Enter house / flat number',
      buildingRequired: 'Enter building or street name',
      pincodeRequired: 'Enter 6-digit pincode',
      pincodeInvalid: 'Enter a valid 6-digit pincode',
      receiverPhoneInvalid: 'Enter a valid 10-digit mobile number',
      addTitle: 'Add address', editTitle: 'Edit address', saveBtn: 'Save address',
      saved: 'Address saved', saveFailed: 'Could not save address',
      removed: 'Address removed', removeFailed: 'Could not remove address',
      defaultUpdated: 'Default address updated', defaultFailed: 'Could not update default',
      empty: 'No saved addresses', emptySub: 'Add home or work address for faster checkout',
      defaultTag: 'DEFAULT', makeDefault: 'Make default', edit: 'Edit', delete: 'Delete',
      addNew: '+ Add new address',
    },
  },
  te: {
    appName: 'MyTownly',
    tagline: 'పిల్లర్‌లో కిరాణా డెలివరీ',
    town: 'పిల్లర్, ఆంధ్ర ప్రదేశ్',
    langToggle: 'English',
    langName: 'తెలుగు',
    blocked: {
      title: 'ఖాతా నిలిపివేయబడింది',
      message: 'మీ ఖాతా బ్లాక్ చేయబడింది. మీరు ఆర్డర్లు చేయలేరు. ఇది తప్పు అని అనిపిస్తే సపోర్ట్‌ను సంప్రదించండి.',
      contact: 'WhatsAppలో సపోర్ట్‌ను సంప్రదించండి',
      logout: 'లాగ్ అవుట్',
    },
    location: {
      title: 'డెలివరీ లొకేషన్ ఇవ్వండి',
      message: 'చెక్అవుట్‌ను వేగవంతం చేయడానికి మరియు రైడర్‌కు సహాయం చేయడానికి మీ GPS ఒకసారి ఉపయోగిస్తాము.',
      enable: 'లొకేషన్ ఇవ్వండి',
      skip: 'ఇప్పుడు వద్దు',
      detecting: 'మీ లొకేషన్ కనుగొంటోంది…',
      confirmTitle: 'మీ చిరునామా నిర్ధారించండి',
      save: 'డిఫాల్ట్ చిరునామాగా సేవ్ చేయండి',
      saved: 'డెలివరీ లొకేషన్ సేవ్ అయింది!',
      denied: 'లొకేషన్ అనుమతి ఇవ్వలేదు. మీరు చిరునామాను మాన్యువల్‌గా జోడించవచ్చు.',
      failed: 'లొకేషన్ కనుగొనలేకపోయాము. మళ్ళీ ప్రయత్నించండి.',
      saveFailed: 'చిరునామా సేవ్ కాలేదు. మళ్ళీ ప్రయత్నించండి.',
    },
    delivery: {
      deliverTo: 'డెలివరీ చేయండి',
      currentLocation: 'ప్రస్తుత లొకేషన్',
      pinnedLocation: 'పిన్ చేసిన లొకేషన్',
      useCurrentLocation: 'నా ప్రస్తుత లొకేషన్ ఉపయోగించండి',
      refreshLocation: 'లొకేషన్ రిఫ్రెష్',
      detecting: 'మీ లొకేషన్ కనుగొంటోంది…',
      gpsFailed: 'లొకేషన్ కనుగొనలేకపోయాము. సేవ్ చిరునామా లేదా మ్యాప్‌లో పిన్ చేయండి.',
      changeLocation: 'మార్చండి',
      savedAddresses: 'సేవ్ చిరునామాలు',
      manageAddresses: 'చిరునామాలు నిర్వహించండి',
      setOnMap: 'మ్యాప్‌లో పిన్ చేయండి',
      adjustOnMap: 'మ్యాప్‌లో పిన్ సర్దుబాటు',
      pinTitle: 'డెలివరీ లొకేషన్ నిర్ధారించండి',
      pinHint: 'మీ ఇంటి ఖచ్చితమైన చోటుకు పిన్ లాగండి. చిరునామా ఆటోమేటిక్‌గా నింపబడుతుంది.',
      confirmPin: 'లొకేషన్ నిర్ధారించండి',
      pinConfirmed: 'డెలివరీ లొకేషన్ నిర్ధారించబడింది',
      updatingAddress: 'చిరునామా అప్‌డేట్ అవుతోంది…',
      whereInPiler: 'పిల్లర్‌లో ఎక్కడ?',
      whereInPilerSub: 'స్థానిక షాపులు ~30 నిమిషాల్లో డెలివర్ చేస్తాయి. రైడర్‌కు సహాయం చేయడానికి మీ స్థలం సెట్ చేయండి.',
      searchPlaceholder: 'ప్రాంతం, వీధి లేదా ల్యాండ్‌మార్క్ వెతకండి',
      searchFailed: 'ఆ ప్రదేశం కనుగొనలేకపోయాము. మ్యాప్ పిన్ ప్రయత్నించండి.',
      gpsHint: 'రైడర్‌లు మీ ఇంటి వద్దకు త్వరగా చేరడానికి సహాయపడుతుంది',
      enable: 'ఇవ్వండి',
      permissionOff: 'లొకేషన్ అనుమతి ఆఫ్‌లో ఉంది',
      permissionOffSub: 'GPS ఇవ్వడానికి ఇవ్వండి నొక్కండి, లేదా క్రింద మ్యాప్‌లో పిన్ చేయండి.',
      browseWithoutLocation: 'లొకేషన్ లేకుండా బ్రౌజ్ చేయండి',
      setLocationBanner: 'వేగవంతమైన చెక్అవుట్ కోసం డెలివరీ లొకేషన్ సెట్ చేయండి',
      outOfAreaTitle: 'పిల్లర్ నుండి 3 కి.మీ లోపు మాత్రమే',
      outOfAreaMessage: 'ఈ పిన్ పిల్లర్ 3 కి.మీ డెలివరీ జోన్‌కు వెలుపల ఉంది. పట్టణానికి దగ్గరగా పిన్ చేయండి.',
      outOfAreaShort: 'పిల్లర్ 3 కి.మీ డెలివరీ జోన్‌కు వెలుపల.',
      notifyExpansion: 'మేము విస్తరించినప్పుడు తెలియజేయండి',
    },
    nav: { home: 'హోమ్', grocery: 'కిరాణా', orders: 'ఆర్డర్లు', profile: 'ప్రొఫైల్' },
    common: {
      back: 'వెనుక', save: 'సేవ్', cancel: 'రద్దు', confirm: 'నిర్ధారించండి', loading: 'లోడ్ అవుతోంది...',
      soon: 'త్వరలో', free: 'ఉచితం', total: 'మొత్తం', search: 'వెతకండి',
      orderNow: 'ఇప్పుడే ఆర్డర్ →', browseGrocery: 'కిరాణా చూడండి', tryAgain: 'మళ్ళీ ప్రయత్నించండి',
    },
    legal: {
      section: 'చట్టపరమైన',
      termsPrefix: 'కొనసాగించడం ద్వారా మీరు మా',
      terms: 'నిబంధనలు',
      termsAnd: ' & ',
      privacy: 'గోప్యతా విధానాన',
    },
    greeting: { morning: 'శుభోదయం', afternoon: 'శుభ మధ్యాహ్నం', evening: 'శుభ సాయంత్రం' },
    home: {
      searchPlaceholder: 'కిరాణా, షాపులు వెతకండి...',
      quickShop: 'షాప్', quickOrders: 'ఆర్డర్లు', quickAddresses: 'చిరునామాలు', quickHelp: 'సహాయం',
      orderGroceries: 'కిరాణా ఆర్డర్ చేయండి', orderSub: 'పిల్లర్ స్థానిక షాపుల నుండి తాజా సరుకులు',
      shopTitle: 'కిరాణా షాపింగ్', shopDesc: '30 నిమిషాల్లో మీ ఇంటి వద్దకు',
      offers: 'మీ కోసం ఆఫర్లు', whyUs: 'ఎందుకు MyTownly?',
      fastDelivery: 'వేగవంతమైన డెలివరీ', fastSub: 'సగటు 30 నిమి',
      cashUpi: 'క్యాష్ & UPI', cashSub: 'మీకు నచ్చిన విధంగా చెల్లించండి',
      madeForPiler: 'పిల్లర్ కోసం', madeSub: 'స్థానిక షాపులు',
      firstOrderPromo: 'మొదటి ఆర్డర్‌కు ఉచిత డెలివరీ!',
      offer1Title: 'మొదటి ఆర్డర్‌కు ఉచిత డెలివరీ!', offer1Desc: 'చెక్అవుట్‌లో ఆటోమేటిక్‌గా వర్తిస్తుంది',
      offer2Title: '₹{amount} పైన ఉచిత డెలివరీ', offer2Desc: 'పిల్లర్‌లో ప్రతి కిరాణా ఆర్డర్‌కు',
      comingSoon: 'పిల్లర్‌కు త్వరలో', autoRides: 'ఆటో రైడ్స్', autoRidesSub: 'లాంచ్ అయినప్పుడు నోటిఫై చేయండి',
      food: 'ఫుడ్ డెలివరీ', foodSub: 'లాంచ్ అయినప్పుడు నోటిఫై చేయండి',
    },
    tour: {
      skip: 'దాటవేయి',
      next: 'తర్వాత →',
      startShopping: 'షాపింగ్ ప్రారంభించండి 🛒',
      welcomeIcon: '🏘️',
      welcomeTitle: 'MyTownlyకు స్వాగతం!',
      welcomeBody: 'అన్నీ ఎక్కడ ఉన్నాయో చూపించే చిన్న టూర్ — 4 స్టెప్‌లు.',
      locationIcon: '📍',
      locationTitle: 'మీ డెలివరీ స్థలం',
      locationBody: 'ముందుగా ఇక్కడ ట్యాప్ చేసి కిరాణా ఎక్కడికి పంపాలో సెట్ చేయండి.',
      shopIcon: '🛒',
      shopTitle: 'కిరాణా షాప్',
      shopBody: 'ఇక్కడ షాప్ తెరవండి — వస్తువులు ఎంచుకుని + నొక్కండి.',
      checkoutIcon: '💳',
      checkoutTitle: 'కార్ట్ & చెక్అవుట్',
      checkoutBody: 'సిద్ధమైతే కార్ట్ ఐకాన్ నొక్కండి. నగదు లేదా UPI — మొదటి ఆర్డర్ ఉచిత డెలివరీ!',
      trackIcon: '📦',
      trackTitle: 'ఆర్డర్లు ట్రాక్',
      trackBody: 'మీ అన్ని ఆర్డర్లు ఇక్కడ. స్టేటస్ & లైవ్ ట్రాకింగ్ చూడండి.',
    },
    login: {
      enterPhone: 'మీ మొబైల్ నంబర్ ఇవ్వండి', phoneSub: 'నిర్ధారించడానికి OTP పంపుతాము',
      sendOtp: 'OTP పంపండి →', enterOtp: 'OTP ఇవ్వండి', sentTo: '+91 {phone} కు పంపాము', change: 'మార్చు',
      verifyOtp: 'OTP ధృవీకరించండి →', resend: 'OTP మళ్ళీ పంపండి', noOtp: 'రాలేదా?',
      yourName: 'మీ పేరు ఏమిటి?', nameSub: 'ఒక్కసారి మాత్రమే — మిమ్మల్ని ఏమని పిలవాలో తెలుసుకోవడానికి 😊',
      namePlaceholder: 'మీ పూర్తి పేరు', letsGo: 'పోదాం! 🎉',
      terms: 'కొనసాగించడం ద్వారా మీరు నిబంధనలు & గోప్యతా విధానానికి అంగీకరిస్తారు',
      otpSent: 'OTP పంపాము! SMS చూడండి 📱', welcome: 'MyTownlyకు స్వాగతం, {name}! 🎉',
      invalidPhone: 'సరైన 10 అంకెల నంబర్ ఇవ్వండి', invalidOtp: 'పూర్తి 6 అంకెల OTP ఇవ్వండి',
      emptyName: 'దయచేసి మీ పేరు ఇవ్వండి',
      phonePlaceholder: '10 అంకెల నంబర్',
      otpHint: 'SMS నుండి OTP పేస్ట్ చేయండి లేదా కీబోర్డ్ పైన సూచనను ట్యాప్ చేయండి',
    },
    authErrors: {
      invalidPhone: 'చెల్లని నంబర్. సరైన 10 అంకెల భారతీయ మొబైల్ నంబర్ ఇవ్వండి.',
      tooManyRequests: 'చాలా ప్రయత్నాలు. కొన్ని నిమిషాలు వేచి మళ్ళీ ప్రయత్నించండి.',
      captchaFailed: 'సెక్యూరిటీ చెక్ విఫలమైంది. పేజీ రిఫ్రెష్ చేసి మళ్ళీ ప్రయత్నించండి.',
      invalidOtp: 'తప్పు OTP. కోడ్ తనిఖీ చేసి మళ్ళీ ప్రయత్నించండి.',
      codeExpired: 'OTP గడువు ముగిసింది. కొత్త OTP కోసం మళ్ళీ పంపండి.',
      missingOtp: 'పూర్తి 6 అంకెల OTP ఇవ్వండి.',
      quotaExceeded: 'SMS పరిమితి ముగిసింది. సపోర్ట్‌ను సంప్రదించండి లేదా తర్వాత ప్రయత్నించండి.',
      appNotAuthorized: 'OTP కోసం యాప్ verify కాలేదు. Firebase → Project settings → in.mytownly.customer → debug SHA-1 జోడించండి.',
      timeout: 'OTP సమయం ముగిసింది. నెట్‌వర్క్ చెక్ చేసి మళ్లీ ప్రయత్నించండి.',
      networkFailed: 'నెట్‌వర్క్ లోపం. ఇంటర్నెట్ కనెక్షన్ తనిఖీ చేయండి.',
      refererBlocked: 'Firebase API key ఈ సైట్‌ను బ్లాక్ చేసింది. Google Cloud Consoleలో HTTP referrers జోడించండి.',
      noOtpSession: 'OTP సెషన్ లేదు. కొత్త OTP అభ్యర్థించండి.',
      profilePermission: 'ప్రొఫైల్ సేవ్ కాలేదు. యాప్ మూసి మళ్ళీ తెరిచి ప్రయత్నించండి.',
      default: 'ఏదో తప్పు జరిగింది. మళ్ళీ ప్రయత్నించండి.',
    },
    notifications: {
      title: 'ఆర్డర్ అప్‌డేట్లు',
      desc: 'ఆర్డర్ ప్యాక్ అయినప్పుడు లేదా డెలివరీకి వెళ్ళినప్పుడు సౌండ్ అలర్ట్',
      enable: 'ఆన్ చేయండి',
      enabled: 'నోటిఫికేషన్లు ఆన్! 🔔',
      blocked: 'నోటిఫికేషన్లు బ్లాక్ — బ్రౌజర్ సెట్టింగ్స్‌లో ఆన్ చేయండి',
      failed: 'నోటిఫికేషన్లు ఆన్ చేయలేకపోయాము',
    },
    grocery: {
      title: 'కిరాణా', shopsNear: 'మీ దగ్గర షాపులు', shopsSub: 'పిల్లర్ అంతటా డెలివరీ',
      searchProducts: 'సరుకులు వెతకండి...', noShops: 'ఇంకా షాపులు లేవు',
      noShopsSub: 'పిల్లర్‌లో స్థానిక షాపులను చేర్చుతున్నాము. త్వరలో చూడండి!',
      noProducts: 'సరుకులు కనిపించలేదు', noProductsSub: 'వేరే కేటగిరీ లేదా సెర్చ్ ప్రయత్నించండి',
      clearSearch: 'సెర్చ్ క్లియర్', viewCart: 'కార్ట్ చూడండి →', items: 'వస్తువు', itemsPlural: 'వస్తువులు',
      addedToCart: 'కార్ట్‌కు జోడించబడింది',
      defaultUnit: '1 ముక్క',
      loadError: 'లోడ్ కాలేదు',
      loadErrorShops: 'కనెక్షన్ తనిఖీ చేసి మళ్ళీ ప్రయత్నించండి.',
      loadErrorProducts: 'ఈ షాప్ సరుకులు లోడ్ కాలేదు. మళ్ళీ ప్రయత్నించండి.',
      categories: { all: 'అన్నీ', vegetables: 'కూరగాయలు', fruits: 'పండ్లు', dairy: 'పాలు', grains: 'ధాన్యాలు', snacks: 'స్నాక్స్', spices: 'స్పైసెస్' },
    },
    cart: {
      title: 'నా కార్ట్', empty: 'మీ కార్ట్ ఖాళీగా ఉంది', emptySub: 'పిల్లర్ స్థానిక షాపుల నుండి కిరాణా జోడించండి',
      deliveryAddress: 'డెలివరీ చిరునామా', manage: 'నిర్వహించు', differentAddress: 'వేరే చిరునామా ఇవ్వండి',
      addressPlaceholder: 'ఇంటి నంబర్, వీధి, ల్యాండ్‌మార్క్ పిల్లర్...',
      priceSummary: 'ధర వివరాలు', subtotal: 'ఉపమొత్తం ({count} వస్తువులు)', deliveryFee: 'డెలివరీ ఫీజు',
      freeDelivery: 'ఉచితం', firstOrderFreeNote: 'మొదటి ఆర్డర్ — ఉచిత డెలివరీ వర్తిస్తుంది',
      paymentMethod: 'చెల్లింపు విధానం', cod: '💵 క్యాష్ ఆన్ డెలివరీ', codSub: 'డెలివరీ అయినప్పుడు చెల్లించండి',
      online: '📱 UPI / కార్డ్', onlineSub: 'ఇప్పుడే సురక్షితంగా చెల్లించండి',
      placeOrder: 'ఆర్డర్ చేయండి — ₹{total}', payOrder: '₹{total} చెల్లించండి →',
      needAddress: 'దయచేసి డెలివరీ చిరునామా ఇవ్వండి', needPinLocation: 'మ్యాప్‌లో పిన్ చేయండి (పిల్లర్ 3 కి.మీ లోపు)', emptyCart: 'కార్ట్ ఖాళీగా ఉంది',
      setLocationForFee: 'ఫీజు చూడటానికి డెలివరీ పిన్ సెట్ చేయండి',
      locationRequired: 'కొనసాగడానికి మ్యాప్‌లో డెలివరీ స్థానం సెట్ చేయండి',
      activeOrderBlock: 'మీకు ఇప్పటికే యాక్టివ్ ఆర్డర్ ఉంది. డెలివరీ/రద్దు అయ్యే వరకు వేచండి.',
      paymentPendingBlock: 'కొత్త ఆర్డర్ చేయడానికి ముందు పెండింగ్ చెల్లింపు పూర్తి చేయండి లేదా రద్దు చేయండి.',
      maxOrderExceeded: 'ఆర్డర్ మొత్తం ₹{max} మించకూడదు',
      orderPlaced: 'ఆర్డర్ విజయవంతం! 🎉', orderFailed: 'ఆర్డర్ విఫలమైంది. మళ్ళీ ప్రయత్నించండి.',
      paymentFailed: 'చెల్లింపు విఫలమైంది: {msg}', paymentSetupFailed: 'చెల్లింపు సెటప్ విఫలమైంది. క్యాష్ ప్రయత్నించండి.',
      paymentDismissed: 'చెల్లింపు రద్దు చేయబడింది.',
      paymentNotVerified: 'చెల్లింపు ధృవీకరించలేకపోయాము. మొత్తం కట్ అయితే సపోర్ట్‌ను సంప్రదించండి.',
      codFallbackTitle: 'క్యాష్‌తో చెల్లించాలా?',
      codFallbackMessage: 'ఆన్‌లైన్ చెల్లింపు పూర్తి కాలేదు. ఈ ఆర్డర్‌ను డెలివరీ సమయంలో క్యాష్‌గా మార్చండి.',
      codFallbackSuccess: 'క్యాష్ ఆన్ డెలివరీతో ఆర్డర్ ప్లేస్ అయింది 🎉',
      codFallbackLater: 'ఇప్పుడు కాదు',
      switchToCod: 'అవును — డెలివరీపై క్యాష్',
      codLabel: 'COD',
      mixedShops: 'కార్ట్‌లో వేరే షాప్ వస్తువులు ఉన్నాయి. తొలగించండి లేదా కార్ట్ క్లియర్ చేయండి.',
      shopSwitchCleared: 'కార్ట్ క్లియర్ — మరొక షాప్‌కు మార్చబడింది.',
      processing: 'ప్రాసెస్ అవుతోంది…',
    },
    orders: {
      title: 'నా ఆర్డర్లు', empty: 'ఇంకా ఆర్డర్లు లేవు', emptySub: 'పిల్లర్ కిరాణా ఆర్డర్లు ఇక్కడ కనిపిస్తాయి',
      orderGroceries: 'కిరాణా ఆర్డర్', paymentPending: 'చెల్లింపు పెండింగ్',
      completePayment: 'చెల్లింపు పూర్తి చేయండి',
      payNow: 'ఇప్పుడు చెల్లించండి',
      pending: 'పెండింగ్', confirmed: 'నిర్ధారించబడింది', ready: 'సిద్ధం',
      onTheWay: 'మార్గంలో', delivered: 'డెలివర్ అయింది', cancelled: 'రద్దు', failed: 'చెల్లింపు విఫలం',
    },
    track: {
      title: 'ఆర్డర్ ట్రాక్', loading: 'మీ ఆర్డర్ లోడ్ అవుతోంది...', progress: 'ఆర్డర్ పురోగతి',
      estimated: 'అంచనా: 25–35 నిమిషాలు', deliveredSuccess: 'విజయవంతంగా డెలివర్ అయింది!',
      orderSummary: 'ఆర్డర్ సారాంశం', totalPaid: 'మొత్తం', orderAgain: 'మళ్ళీ ఆర్డర్ 🎉',
      copied: 'ఆర్డర్ ID కాపీ అయింది!',
      notFound: 'ఆర్డర్ కనుగొనబడలేదు',
      notFoundSub: 'ఈ ఆర్డర్ లేదు లేదా యాక్సెస్ లేదు. నా ఆర్డర్లు చూడండి.',
      loadError: 'ఆర్డర్ లోడ్ కాలేదు',
      loadErrorSub: 'కనెక్షన్ తనిఖీ చేసి మళ్ళీ ప్రయత్నించండి.',
      cancelOrder: 'ఆర్డర్ రద్దు చేయండి',
      cancelConfirmTitle: 'ఈ ఆర్డర్ రద్దు చేయాలా?',
      cancelConfirm: 'షాప్ ఆమోదించే ముందు మాత్రమే రద్దు చేయవచ్చు.',
      cancelling: 'రద్దు చేస్తోంది…',
      cancelled: 'ఆర్డర్ రద్దు అయింది',
      cancelFailed: 'రద్దు చేయలేకపోయాం — షాప్ ఇప్పటికే ఆమోదించి ఉండవచ్చు',
      needHelp: 'ఈ ఆర్డర్‌కు సహాయం కావాలా?',
      whatsappHelp: 'WhatsApp లో చాట్ చేయండి — మీ ఆర్డర్ వివరాలతో సమాధానం ఇస్తాం',
      payWithCod: '💵 డెలివరీపై క్యాష్',
      steps: {
        pending: { label: 'ఆర్డర్ చేయబడింది', desc: 'మీ ఆర్డర్ స్వీకరించబడింది' },
        payment_pending: { label: 'చెల్లింపు పెండింగ్', desc: 'ఆన్‌లైన్ చెల్లించండి, క్యాష్‌కు మార్చండి లేదా రద్దు చేయండి' },
        confirmed: { label: 'నిర్ధారించబడింది', desc: 'షాప్ మీ ఆర్డర్ తయారు చేస్తోంది' },
        ready: { label: 'సిద్ధం', desc: 'ఆర్డర్ ప్యాక్ అయి పికప్ కోసం వేచి ఉంది' },
        picked_up: { label: 'మార్గంలో', desc: 'రైడర్ మీ వద్దకు వస్తున్నారు' },
        delivered: { label: 'డెలివర్ అయింది', desc: 'ఆనందించండి!' },
        cancelled: { label: 'ఆర్డర్ రద్దు', desc: 'ఈ ఆర్డర్ రద్దు చేయబడింది' },
        failed: { label: 'చెల్లింపు విఫలం', desc: 'మళ్ళీ ఆన్‌లైన్ ప్రయత్నించండి లేదా క్యాష్‌తో చెల్లించండి' },
      },
      deliveryPartner: 'డెలివరీ పార్ట్నర్',
      rateRider: 'డెలివరీకి రేటింగ్ ఇవ్వండి',
      rateRiderSub: '{name} ఎలా ఉన్నారు?',
      submitRating: 'రేటింగ్ సమర్పించండి',
      ratingThanks: 'మీ అభిప్రాయానికి ధన్యవాదాలు!',
      ratingFailed: 'రేటింగ్ సేవ్ కాలేదు. మళ్ళీ ప్రయత్నించండి.',
      ratedStars: 'మీరు {stars} నక్షత్రాలు ఇచ్చారు',
    },
    profile: {
      account: 'ఖాతా',
      completeProfile: 'మీ ప్రొఫైల్ పూర్తి చేయండి',
      addYourName: 'మంచి అనుభవం కోసం మీ పేరు జోడించండి',
      orderCount: '{count} ఆర్డర్లు',
      deliveredCount: '{count} డెలివర్',
      activeOrder: 'ఆర్డర్ ప్రోగ్రెస్‌లో',
      track: 'ట్రాక్',
      editName: 'పేరు మార్చు', nameUpdated: 'పేరు అప్‌డేట్ అయింది', loggedOut: 'లాగ్ అవుట్ అయ్యారు',
      memberSince: '{date} నుండి సభ్యుడు',
      statsOrders: 'ఆర్డర్లు', statsDelivered: 'డెలివర్ అయింది', statsAddresses: 'చిరునామాలు',
      quickActions: 'త్వరిత చర్యలు', shopNow: 'ఇప్పుడే షాప్', viewOrders: 'ఆర్డర్లు చూడండి',
      defaultAddress: 'డిఫాల్ట్ డెలివరీ చిరునామా', addAddress: 'మీ చిరునామా జోడించండి',
      noAddressSub: 'వేగవంతమైన చెక్అవుట్ కోసం ఇల్లు లేదా ఆఫీసు సేవ్ చేయండి',
      referTitle: 'రిఫర్ చేసి ₹{amount} సంపాదించండి', referSub: 'పిల్లర్‌లో స్నేహితులతో మీ కోడ్ షేర్ చేయండి',
      copyCode: 'కాపీ', codeCopied: 'కాపీ అయింది!',
      sectionAccount: 'ఖాతా', sectionSettings: 'సెట్టింగ్స్', sectionSupport: 'సపోర్ట్',
      myOrders: 'నా ఆర్డర్లు', myOrdersSub: 'ట్రాక్ & గత ఆర్డర్లు',
      addresses: 'సేవ్ చిరునామాలు', addressesSub: 'ఇల్లు, ఆఫీసు & మరిన్ని',
      payments: 'చెల్లింపులు', paymentsSub: 'UPI, క్యాష్ ఆన్ డెలివరీ',
      refer: 'రిఫర్ & సంపాదించు', referSub: 'రిఫరల్‌కు ₹50',
      help: 'సహాయం & సపోర్ట్', helpSub: 'WhatsApp, కాల్ & FAQ',
      logout: 'లాగ్ అవుట్', version: 'MyTownly v{version} · ❤️ తో పిల్లర్, AP',
      language: 'భాష', languageSub: 'English / తెలుగు',
    },
    help: {
      title: 'సహాయం & సపోర్ట్',
      whatsappTitle: 'WhatsApp లో చాట్',
      whatsappSub: 'వేగవంతమైన స్పందన · సాధారణంగా 1 గంటలో',
      callTitle: 'మాకు కాల్ చేయండి',
      emailTitle: 'ఇమెయిల్ సపోర్ట్',
      faqTitle: 'తరచుగా అడిగే ప్రశ్నలు',
      faq: {
        deliveryQ: 'డెలివరీకి ఎంత సమయం పడుతుంది?',
        deliveryA: 'పిల్లర్‌లో చాలా ఆర్డర్లు 30–35 నిమిషాల్లో డెలివర్ అవుతాయి — షాప్ మరియు మీ చిరునామా మీద ఆధారపడి ఉంటుంది.',
        paymentQ: 'ఏ చెల్లింపు విధానాలు అంగీకరిస్తారు?',
        paymentA: 'క్యాష్ ఆన్ డెలివరీ (COD) మరియు Razorpay ద్వారా UPI, కార్డ్, వాలెట్ ఆన్‌లైన్ చెల్లింపులు.',
        minimumQ: 'కనీస ఆర్డర్ మొత్తం ఉందా?',
        minimumA: 'కనీస ఆర్డర్ లేదు. ప్రతి ఆర్డర్‌కు ₹20 డెలివరీ ఫీజు వర్తిస్తుంది.',
        trackQ: 'నా ఆర్డర్ ట్రాక్ చేయగలనా?',
        trackA: 'అవును! కింది మెనూలో ఆర్డర్లు ఓపెన్ చేసి మీ ఆర్డర్‌పై ట్యాప్ చేయండి — లైవ్ స్టేటస్ చూడండి.',
        areaQ: 'ఏ ప్రాంతాలకు డెలివరీ చేస్తారు?',
        areaA: 'ప్రస్తుతం {town} లోపల డెలివరీ చేస్తున్నాము. త్వరలో సమీప ప్రాంతాలకు విస్తరిస్తాము.',
      },
    },
    splash: { sub: 'కిరాణా డెలివరీ · పిల్లర్' },
    address: {
      saveAs: 'ఇలా సేవ్ చేయండి',
      types: { home: 'ఇల్లు', work: 'ఆఫీసు', other: 'ఇతర' },
      houseNo: 'ఇల్లు / ఫ్లాట్ / బ్లాక్ నం.',
      houseNoPlaceholder: 'ఉదా. 12-34, ఫ్లాట్ 2B',
      building: 'బిల్డింగ్ / వీధి / కాలనీ',
      buildingPlaceholder: 'ఉదా. శ్రీరామ కాలనీ, మెయిన్ రోడ్',
      landmark: 'ల్యాండ్‌మార్క్ (ఐచ్ఛికం)',
      landmarkPlaceholder: 'ఉదా. హనుమాన్ టెంపుల్ దగ్గర',
      area: 'ఏరియా / లోకాలిటీ',
      pincode: 'పిన్‌కోడ్',
      cityState: 'నగరం',
      receiverName: 'స్వీకరించే వ్యక్తి (ఐచ్ఛికం)',
      receiverNamePlaceholder: 'ఆర్డర్ ఎవరు స్వీకరిస్తారు?',
      receiverPhone: 'స్వీకరించే మొబైల్ (ఐచ్ఛికం)',
      setDefault: 'డిఫాల్ట్ డెలివరీ చిరునామాగా సెట్ చేయండి',
      houseNoRequired: 'ఇల్లు / ఫ్లాట్ నంబర్ ఇవ్వండి',
      buildingRequired: 'బిల్డింగ్ లేదా వీధి పేరు ఇవ్వండి',
      pincodeRequired: '6 అంకెల పిన్‌కోడ్ ఇవ్వండి',
      pincodeInvalid: 'సరైన 6 అంకెల పిన్‌కోడ్ ఇవ్వండి',
      receiverPhoneInvalid: 'సరైన 10 అంకెల మొబైల్ నంబర్ ఇవ్వండి',
      addTitle: 'చిరునామా జోడించండి', editTitle: 'చిరునామా మార్చండి', saveBtn: 'చిరునామా సేవ్',
      saved: 'చిరునామా సేవ్ అయింది', saveFailed: 'చిరునామా సేవ్ కాలేదు',
      removed: 'చిరునామా తొలగించబడింది', removeFailed: 'తొలగించలేకపోయాము',
      defaultUpdated: 'డిఫాల్ట్ చిరునామా అప్‌డేట్', defaultFailed: 'డిఫాల్ట్ అప్‌డేట్ కాలేదు',
      empty: 'సేవ్ చిరునామాలు లేవు', emptySub: 'వేగవంతమైన చెక్అవుట్ కోసం ఇల్లు లేదా ఆఫీసు జోడించండి',
      defaultTag: 'డిఫాల్ట్', makeDefault: 'డిఫాల్ట్ చేయండి', edit: 'మార్చు', delete: 'తొలగించు',
      addNew: '+ కొత్త చిరునామా',
    },
  },
};

/** Replace {key} placeholders in translation strings */
export const formatT = (str, vars = {}) => {
  if (!str) return '';
  return Object.entries(vars).reduce((s, [k, v]) => s.replace(new RegExp(`\\{${k}\\}`, 'g'), v), str);
};
